import {
    CatalogApiObject,
    DossierOpenSearch,
    useFormaliteService,
    useFormulaireService,
} from '@europrocurement/l2d-domain';
import { getPrestationsPayload } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider/functions';

const useAddFormality = () => {
    const { prestationFormaliteApi } = useFormaliteService();
    const { formulairesApi } = useFormulaireService();

    const addFormality = async (
        dossier: DossierOpenSearch,
        catalogs: CatalogApiObject[],
        resetStatus: boolean,
    ) => {
        const payloads = await getPrestationsPayload(catalogs, formulairesApi, resetStatus);

        const promises = payloads.map((payload) =>
            prestationFormaliteApi.apiPrestationsPost({
                prestationCreatePrestationDtoJsonldPrestationCreate: {
                    dossier: dossier.id as unknown as string,
                    libelle: payload.libelle as string,
                    ...payload,
                },
            }),
        );

        return await Promise.all(promises);
    };

    return { addFormality };
};

export default useAddFormality;
